"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DeleteCellView = function DeleteCellView(_ref) {
  var column = _ref.column,
    row = _ref.row;
  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    scope: "col",
    className: "delete_row"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disableRipple: true,
    className: "del_row_btn",
    onClick: function onClick() {
      return column.cellEventHandler(row);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.DeleteOutline, {
    className: "del_row_btn_icon",
    fontSize: "small"
  })));
};
var _default = DeleteCellView;
exports.default = _default;